module.exports = __webpack_public_path__ + "img/NIHRlogo.73830e03.png";